<template>
  <div v-if="localLoading || loading" class="d-flex justify-center py-5" :class="{ 'block-overlay': block }">
    <v-overlay v-if="block" :value="localLoading || loading" absolute opacity="0.05">
      <v-progress-circular indeterminate :size="size" :color="color"></v-progress-circular>
    </v-overlay>

    <v-progress-circular v-else indeterminate :size="size" :color="color"></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "Loader",

  props: {
    size: {
      type: Number,
      default: 40,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    block: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: "blue",
    },
  },

  data: () => ({
    localLoading: false,
  }),

  methods: {
    show() {
      this.localLoading = true;
    },

    hide() {
      this.localLoading = false;
    },
  },
};
</script>

<style scoped>
.block-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
